import React, { useMemo } from 'react'
import { Icon } from '@manychat/manyui'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'

import * as triggerStyle from './Trigger.styles'

const FallbackIcon = Icon.OrphanIntegration

export const TriggerIcon = ({ trigger }: { trigger: FlowChartTrigger }) => {
  const TriggerIcon = trigger.icon.icon || FallbackIcon
  const triggerImage = useMemo(() => {
    if (typeof TriggerIcon === 'string') {
      return TriggerIcon
    }

    return convertToIconString(TriggerIcon, {
      color: sharedStyles.Colors.STARTING_STEP_ICON,
      size: sharedStyles.IconSizes.MEDIUM * 2,
    })
  }, [TriggerIcon])

  return <sprite image={triggerImage} style={triggerStyle.IconStyle} />
}
